import React, { useState, useContext} from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Typography from "@material-ui/core/Typography";
import { Checkbox, IconButton } from "@material-ui/core";
import { RequestSummaryContext } from "../../context/RequestSummaryContext";
import { TableViewSelectionContext } from "../../context/TableViewSelectionContext";
import DashboardToolBox from "../toolbox/ToolBox";
import _ from "lodash";
import JobUtils from "../../utils/JobsUtils";
import ConfigUtils from "../../utils/ConfigUtils";
import SummaryUtils from "../../utils/SummaryUtils";
import Moment from "moment";
import { ReactComponent as EditJob } from "../../assets/icons/edit.svg";
import useStoreConfig from "../../hooks/useStoreConfig";
import { UserContext } from "../../context/UserContext";
import { useHistory, Link } from "react-router-dom";
import "../../styles/summary.scss";
import {StyledBlueButton} from "../../styles/BootstrapStyles";
import {Row} from "react-bootstrap";
import FilesModal from "../modal/FilesModal";
import { UserRoles } from "../../constants/UserRoles";

const headers = [
  { label: "", type: "select-job", style: { width: '50px', maxWidth: '50px' } },
  { label: "", type: "collapse-button", fields: "" },
  { label: "Sources", type: "source", value: "source" },
  { label: "Processing", type: "processor", value: "processor" },
  { label: "Deliveries", type: "delivery", value: "delivery" },
  { label: "Job Id", type: "jobId", value: "jobId" },
  { label: "Due Date", type: "dueDate", value: "dueDate" },
  {
    label: "Status",
    type: "status",
    value: "status"
  },
  {
    label: "Assigned To",
    type: "assignedTo",
    value: "assignedTo.fullName"
  },
];

const TYPES = {
  COPY: "copy",
  REDO: "redo"
}

const RequestSummaryTable = () => {
  const JobTypes = ConfigUtils.getJobTypes();
  const [indexValue, setIndex] = useState(0);
  const [order, setOrder] = useState("asc");
  const { upadateSelection, reset } = useContext(TableViewSelectionContext);
  const [selectAll, setSelectAll] = useState(false);
  const [selectionMap, setSelectionMap] = useState({});
  const { userRole, faspexAccountMapping } = useContext(UserContext);
  const { ConfigStore } = useStoreConfig();
  const { request, _setSelectAll, resetJob } = useContext(
      RequestSummaryContext
  );
  const [open, setOpen] = useState("");
  const history = useHistory();

  function sortByColumn(a, colIndex) {
    const getValue = _.get(headers[colIndex], "value");
    const sortedArray = a.sort(sortFunction);
    function sortFunction(aParam, bParam) {
      aParam = JSON.stringify(_.get(aParam, getValue, ""), null, 1).toLowerCase();
      bParam = JSON.stringify(_.get(bParam, getValue, ""), null, 1).toLowerCase();
      if (_.isEqual(aParam, bParam)) {
        return 0;
      } else {
        if (order === "desc") {
          return aParam > bParam ? -1 : 1;
        } else {
          return aParam < bParam ? -1 : 1;
        }
      }
    }
    return sortedArray;
  }
  const renderDeliveryItem = (updateDel, job) => {
    if (_.get(updateDel, "deliveryOption") === 'Screeners.com') {
      updateDel.episodeCliptitle = _.get(job && job.processor, "outputFilename");
    }
    const deliveryMethod = _.find(JobUtils.getJobSpecificDeliveryTypes(_.get(job, "jobType")), (delivery) => {
      return (
        _.camelCase(_.get(delivery, "label")) === _.camelCase(_.get(updateDel, "deliveryOption"))
      );
    });

    const deliveryHeaders = JobUtils.filterS3OnlyHeaders(
      SummaryUtils.getHeaders({
        metadata: _.get(deliveryMethod, "metadata"),
        overrideMetadata: _.get(deliveryMethod && deliveryMethod.override, "metadata"),
        readOnlyMetadata: _.get(deliveryMethod, "readOnlyMetadata"),
        overrideReadOnlyMetadata: _.get(deliveryMethod && deliveryMethod.override, "readOnlyMetadata")
      }, updateDel),
      _.get(updateDel, "account"),
      faspexAccountMapping
    );
    return _.map(deliveryHeaders, (column, index) => {
      return SummaryUtils.hasEmptyFields(column.fields, updateDel) ? null : (
        <React.Fragment key={index}>
          {column.label + " : " + SummaryUtils.getValue(column.fields, updateDel)}
          <br />
        </React.Fragment>
      );
    });
  };

  const renderTable = (job, header) => {
    const value = _.get(job, header.value, "");
    const type = _.get(header, "type");
    switch (type) {
      case "select-job":
        const id = _.get(job, "_id");
        const jobs = _.get(request, "jobs", []);
        return (
          <FormControlLabel
            key={id}
            control={
              <Checkbox
                checked={!!selectionMap[id]}
                onChange={(e) => {
                  const checked = e.target.checked;
                  selectionMap[id] = checked;
                  const selectedJobIds = _.keys(selectionMap).filter(key => selectionMap[key]);
                  const isSelectAll = !_.isEmpty(selectedJobIds) && selectedJobIds.length === jobs.length;
                  setSelectAll(isSelectAll);
                  _setSelectAll(selectedJobIds.length > 1);
                  setSelectionMap(selectionMap);
                  if (selectedJobIds.length === 0) {
                    reset();
                    resetJob();
                  } else {
                    const jobsArray = _.filter(jobs, (jobData) => {
                      return _.includes(selectedJobIds, _.get(jobData, "_id"));
                    });
                    const ids = _.map(jobsArray, (jobValue) => _.get(jobValue, "_id"));
                    const selectionDataValue = {
                      requestId: _.get(request, "requestId"),
                      job: "",
                      recordId: ids,
                      total: ids.length,
                      isDraft: false,
                      status: "",
                      mode: "requestSummary",
                      jobData: jobsArray,
                    };
                    upadateSelection(selectionDataValue);
                  }                 
                }}
              />
            }
            label=""
          />
        );
      case "collapse-button":
        return JobUtils.isEditable(_.get(job, "status")) && (
            <Link to={"/request?jobId=" + _.get(job, "_id")}>
              <IconButton
                  disabled={!JobUtils.statusCheck("editJob", _.get(job, "status"), userRole)}
                  aria-label="add an alarm">
                <EditJob style={{ color: "#fefefe" }} />
              </IconButton>
            </Link>
        );
      case "source":
        const jobType = _.get(job, "jobType");
        const sourceType = JobUtils.getSourceType(_.get(job, "source"));
        const sourceLocation = _.find(
            _.get(
                _.find(JobTypes, (typeValue) => _.get(typeValue, "jobType") === jobType),
                "sourceDefinition"
            ),
            (source) => _.get(source, "value") === sourceType
        );
        const isStitch = _.get(job, "source.type") === "CompositeJobAsset";
        const sourceList = isStitch ? _.get(job, "source.simpleJobAssets") : [_.get(job, "source")];
        const isGcssnyContentApp = _.some(_.get(job, "delivery", []), (delivery) =>
          _.get(delivery, "destination.dropboxName") === "GCSSNY-MX_Content App"
          || _.get(delivery, "attributes.dropboxName") === "GCSSNY-MX_Content App"
        );
        const filesModalId = isGcssnyContentApp ? "GCSSNY-MX_Content App" : sourceList[0].cid;
        const list = _.map(sourceList, (source, idx) => {
          const fields = _.map(
            SummaryUtils.getHeaders({
              metadata: _.get(sourceLocation, "metadata"),
              overrideMetadata: _.get(sourceLocation && sourceLocation.override, "metadata"),
              readOnlyMetadata: _.get(sourceLocation, "readOnlyMetadata"),
              overrideReadOnlyMetadata: _.get(sourceLocation && sourceLocation.override, "readOnlyMetadata")
            }, source),
            (column, index) => {
              const valueData = SummaryUtils.getValue(
                column.fields,
                JobUtils.updateSourceField(source)
              );
              const renderValueData = () => {
                if(column.fields[0].type === "files") {
                  return (
                    <span className="fileModalWrapper">
                      <span className="fileAnchor" onClick={() => {setOpen(filesModalId)}}>{valueData}</span>
                      <span>
                        <FilesModal
                          show={open === filesModalId}
                          files={sourceList[0].files}
                          onClose={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setOpen("");
                          }}
                        />
                      </span>
                    </span>
                  )
                }else {
                  return valueData;
                }
              }
              return SummaryUtils.hasEmptyFields(
                column.fields,
                JobUtils.updateSourceField(source)
              ) ? null : (
                <span style={{ color: column.color && valueData === 'Yes' ? column.color : 'inherit' }} key={"request_modal_soure" + index}>
                  {column.label + " : "}
                  {renderValueData()}
                  <br />
                </span>
              );
            }
          );
          return isStitch ? (<div style={{ marginTop: idx > 0 ? '15px' : 0 }}>
            {fields}
          </div>) : fields;
        });
        return isStitch ? <>
          <h4>Stitched Source Assets:</h4>
          {list}
        </> : list;

      case "processor":
        const processingHeaders = SummaryUtils.getProcessorHeaders(job, JobUtils.updateProcess(value));
        const processHeader = JobUtils.orderProcessingSummary(processingHeaders,job);
        const processLabel = JobUtils.getSelectedProcessingTypeLabel(job);

        return (
          <React.Fragment key={"request_modal_processor"}>
            {processLabel ? <span style={{ color: "rgb(118, 221, 251)", display: "flex" }}>
              {/* TO DO - remove hardcoding */}
              { _.get(job, "jobType")==='WB_SCREENERS'?'WBD Screeners MP4 (1080)': processLabel}
            </span> : null}
            {_.map(processHeader,
              (column, index) => {
                return SummaryUtils.hasEmptyFields(
                  column.fields,
                  JobUtils.updateProcess(value)
                ) ? null : (
                  <React.Fragment key={index}>
                    {column.label +
                      " : " +
                      SummaryUtils.getValue(column.fields, JobUtils.updateProcess(value))}
                    <br />
                  </React.Fragment>
                );
              }
            )}
          </React.Fragment>
        );
      case "delivery":
        const groupedDeliveries = _.groupBy(_.map(value, delivery => ({...JobUtils.updateDelivery(delivery)})), "deliveryOption");
        return _.map(groupedDeliveries, (dels, delName) => {
          return (
            <React.Fragment key={"delivery_modal" + delName}>
              <span style={{ color: "rgb(118, 221, 251)", display: "flex" }}>
                {SummaryUtils.getDeliveryLabel({ deliveryOption: delName })}
              </span>
              {_.map(dels, (updateDel) => renderDeliveryItem(updateDel, job))}
              {_.size(value) > 1 ? <br /> : null}
            </React.Fragment>
          );
        });
      case "jobId":
        const jobId = JobUtils.transformJobId(value);
        return (
            <Link to={"/summary?id=" + _.get(job, "_id")} style={{ color: "#2C82C9" }}>
              {jobId}
            </Link>
        );
      case "dueDate":
        const dueDate = Moment(value).format("MM/DD/YYYY");
        const dueTime = _.get(job, "dueTime", "");

        return _.isEmpty(dueTime) ? dueDate : dueDate + ", " + dueTime;
      case "status":
        const findRole = userRole !== "requestor" || job["jobType"] === "MEDIA_REQUEST" ? "ops" : userRole;
        const findValue = _.result(_.find(ConfigStore.statuses(), { role: findRole }), "statuses");
        const labelValue = _.find(findValue, ["value", value]);
        return _.get(labelValue, "label", "");
      default:
        return value;
    }
  };

  const headerView = () => {
    if (!JobUtils.statusCheck("editJob", null, userRole, _.get(request, 'jobType'))) {
      const rejectFn = userRole === UserRoles.CR_API || userRole === UserRoles.MEDIAREQUEST || 
      ((userRole === UserRoles.SUPERADMIN || userRole === UserRoles.GLOBALADMIN || userRole === UserRoles.REQUESTOR || userRole === UserRoles.OPS) && (_.get(request, 'jobType') === 'CONTENT_REQUEST_API' || 
       _.get(request, 'jobType') === 'MEDIA_REQUEST')) ?
        (header) => ["select-job", "collapse-button", "processor", "assignedTo"].includes(header.type) :
        (header) => header.type === "select-job" || header.type === "collapse-button" 
      return _.reject(headers, rejectFn);
    } else {
      return headers;
    }
  };

  const redirectToRequest = (type) => {
    history.push("/request?requestId=" + _.get(request, "_id") + "&type=" + type, "_self");
  }

  return (
      <>
        <Row className="m-0 p-0 summaryFieldsRow">
            {_.isEmpty(_.get(request, "jobs")) || !JobUtils.statusCheck("editJob", null, userRole, _.get(request, 'jobType')) ? null : (
                <div className="summaryDiv">
                  <FormControlLabel
                      className="m-0"
                      control={
                        <Checkbox
                            checked={selectAll}
                            className="summaryCheckbox"
                            onChange={(e) => {
                              setSelectAll(e.target.checked);
                              _setSelectAll(e.target.checked);
                              if (e.target.checked) {
                                const jobs = _.get(request, "jobs", []);
                                const jobSelectionMap = {};
                                jobs.forEach((job) => jobSelectionMap[_.get(job, "_id")] = true);
                                setSelectionMap(jobSelectionMap);
                                const checkedArray = ["COMPLETE", "CANCELLED"];
                                //Filter jobs with completed & cancelled status
                                const jobsArray = _.filter(jobs, (jobData) => {
                                  return !_.includes(checkedArray, _.get(jobData, "status"));
                                });
                                let ids = _.map(jobsArray, (job) => _.get(job, "_id"));
                                let selectionDataValue = {
                                  requestId: _.get(request, "requestId"),
                                  job: "",
                                  recordId: ids,
                                  total: ids.length,
                                  isDraft: false,
                                  status: "",
                                  mode: "requestSummary",
                                  jobData: jobsArray,
                                };
                                upadateSelection(selectionDataValue);
                              } else {
                                setSelectionMap({});
                                reset();
                                resetJob();
                              }
                            }}
                        />
                      }
                      label={
                        <Typography className="summaryCheckboxLabel">Select all open jobs</Typography>
                      }
                  />
                </div>
            )}
          <div className="summaryDiv">
            {(userRole === UserRoles.ADMIN || 
            ((userRole === UserRoles.SUPERADMIN || userRole === UserRoles.GLOBALADMIN || userRole === UserRoles.OPS) && (_.get(request, 'jobType') !== 'CONTENT_REQUEST_API' &&  _.get(request, 'jobType') !== 'MEDIA_REQUEST'))) && 
            <DashboardToolBox mode="requestSummary" />}
          </div>
          <div className="summaryButtonsDiv">
            {(userRole === UserRoles.ADMIN || 
            ((userRole === UserRoles.SUPERADMIN || userRole === UserRoles.GLOBALADMIN || userRole === UserRoles.OPS || userRole === UserRoles.REQUESTOR) && (_.get(request, 'jobType') !== 'CONTENT_REQUEST_API' &&  _.get(request, 'jobType') !== 'MEDIA_REQUEST'))) && (
                <StyledBlueButton variant="contained"
                             onClick={(e) => {
                               e.preventDefault();
                               redirectToRequest(TYPES.COPY);
                             }}>
                  Copy Order
                </StyledBlueButton>
            )}
            {(userRole === UserRoles.ADMIN || 
            ((userRole === UserRoles.SUPERADMIN || userRole === UserRoles.GLOBALADMIN || userRole === UserRoles.OPS) && (_.get(request, 'jobType') !== 'CONTENT_REQUEST_API' &&  _.get(request, 'jobType') !== 'MEDIA_REQUEST'))) && (
                <StyledBlueButton variant="contained"
                             onClick={(e) => {
                               e.preventDefault();
                               redirectToRequest(TYPES.REDO);
                             }}>
                  Copy As Requestor
                </StyledBlueButton>
            )}
          </div>
        </Row>

        {_.isEmpty(_.get(request, "jobs")) ? null : (
            <TableContainer id={"Request_modal_container"} className="tableContainer">
              <Table className="m-0 p-0" stickyHeader aria-label="sticky table" id={"request-table"}>
                <TableHead id={"request-table-head"}>
                  <TableRow key={"request_header_row"}>
                    {headerView().map((column, index) => (
                        <TableCell key={"request_head" + index} className="summaryTableHeader" style={{ ...(column.style || {}) }}>
                          <TableSortLabel
                              active={indexValue === index}
                              hidden={_.isEmpty(column.label)}
                              direction={order === "asc" ? "asc" : "desc"}
                              onClick={(e) => {
                                e.preventDefault();

                                if (indexValue === index) {
                                  order === "asc" ? setOrder("desc") : setOrder("asc");
                                } else {
                                  setOrder("asc");
                                }
                                setIndex(index);
                              }}>
                            {column.label}
                          </TableSortLabel>
                        </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {_.isEmpty(_.get(request, "jobs"))
                      ? null
                      : sortByColumn(_.get(request, "jobs"), indexValue).map((job, key) => {
                        return (
                            <TableRow
                                key={"request_modal_row" + key}
                            >
                              {headerView().map((header, index) => {
                                return (
                                    <TableCell
                                        className="summaryTableRow"
                                        style={{...(header.style || {}) }}
                                        key={"viewTable" + index}
                                    >
                                      {renderTable(job, header)}
                                    </TableCell>
                                );
                              })}
                            </TableRow>
                        );
                      })}
                </TableBody>
              </Table>
            </TableContainer>
        )}
      </>
  );
};

export default React.memo(RequestSummaryTable);